import apiClient from '../config/axios';
import { ENDPOINTS } from '../constants/endpoints';
import clientService from './clientService'; // Adjust the import based on your file structure

export const authService = {
  // Login function
  login: async (credentials) => {
    try {
      console.log('Attempting to login with credentials:', credentials);
      const response = await apiClient.post(ENDPOINTS.LOGIN, {
        login: credentials.login,
        password: credentials.password,
      });

      const { accessToken } = response.data;
      console.log('Login response:', response.data);
      if (accessToken) {
        localStorage.setItem('accessToken', accessToken);

        const payload = JSON.parse(atob(accessToken.split('.')[1]));
        let userInfo = {
          jti: payload.jti,
          nameIdentifier: payload["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier"],
          userName: payload.UserName,
          idUser: payload.IdUser,
          isAdmin: payload.IsAdmin === true || payload.IsAdmin === '1',
          nom: payload.Nom,
          prenom: payload.Prenom,
          exp: payload.exp,
          iss: payload.iss,
          aud: payload.aud,
          fullName: `${payload.Prenom} ${payload.Nom}`,
          displayName: payload.UserName,
        };

        // If not admin, fetch client info and add logo
        if (!userInfo.isAdmin && userInfo.idUser) {
          try {
            const clientRes = await clientService.getClientById(userInfo.idUser);
            if (clientRes.success && clientRes.data?.logo) {
              userInfo.logo = clientRes.data.logo;
            }
          } catch (e) {
            console.warn('Could not fetch client logo:', e);
          }
        }

        console.log('User Info:', userInfo);
        localStorage.setItem('userInfo', JSON.stringify(userInfo));

        console.log('Decoded Token Payload:', payload);
        console.log('Stored User Info:', userInfo);

        return { success: true, data: response.data, userInfo };
      }

      return { success: false, message: 'No access token received' };
    } catch (error) {
      console.error('Login error:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Échec de la connexion. Veuillez réessayer.',
      };
    }
  },

  // Logout function
  logout: () => {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('userInfo');
  },

  // Check if user is authenticated
  isAuthenticated: () => {
    const token = localStorage.getItem('accessToken');
    if (!token) return false;
    
    try {
      // Check if token is expired
      const payload = JSON.parse(atob(token.split('.')[1]));
      const currentTime = Date.now() / 1000;
      return payload.exp > currentTime;
    } catch (error) {
      console.error('Token validation error:', error);
      return false;
    }
  },

  // Get current user info
  getCurrentUser: () => {
    const userInfo = localStorage.getItem('userInfo');
    return userInfo ? JSON.parse(userInfo) : null;
  },

  // Get access token
  getToken: () => {
    return localStorage.getItem('accessToken');
  },

  // Get user role/permissions
  getUserRole: () => {
    const user = authService.getCurrentUser();
    return {
      isAdmin: user?.isAdmin || false,
      canManageUsers: user?.isAdmin || false,
      canViewReports: true, // All authenticated users can view reports
      canManageArticles: user?.isAdmin || false,
    };
  },

  // Check if token will expire soon (within 5 minutes)
  isTokenExpiringSoon: () => {
    const token = localStorage.getItem('accessToken');
    if (!token) return true;
    
    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      const currentTime = Date.now() / 1000;
      const fiveMinutes = 5 * 60; // 5 minutes in seconds
      return (payload.exp - currentTime) < fiveMinutes;
    } catch (error) {
      return true;
    }
  },

  // Get token expiration date
  getTokenExpirationDate: () => {
    const token = localStorage.getItem('accessToken');
    if (!token) return null;
    
    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      return new Date(payload.exp * 1000);
    } catch (error) {
      return null;
    }
  },
};

export default authService;